export function selectedRow(row) {
  return (row as any).selected === true
    ? '1px solid #2DC76D'
    : '0.5px solid #D7E3F1';
}
